import { AdvanceBatchStatus } from '@/types';

/**
 * Advance COD v2 design status buckets (DESIGN-v2-inventory.md §5). The
 * backend batch lifecycle has 11 statuses; the approved design collapses
 * them into the 5 pills it renders. Rejected + Queued rows show em-dash in
 * every money column (design rule + component-logic.js).
 */
export type AdvanceDesignStatus = 'in_progress' | 'disbursed' | 'closed' | 'rejected' | 'queued';

/** Collapse the 11 backend statuses into the 5 design pills. */
export const toDesignStatus = (status: AdvanceBatchStatus): AdvanceDesignStatus => {
  switch (status) {
    case 'in_progress':
      return 'in_progress';
    case 'disbursed':
      return 'disbursed';
    case 'closed':
      return 'closed';
    case 'rejected':
    case 'failed':
      return 'rejected';
    // draft | submitting | pending | queued | approved | partially_approved
    default:
      return 'queued';
  }
};

/** Exact design pill colors (DESIGN-v2-inventory.md §5 / component-logic.js). */
export const DESIGN_PILL_STYLE: Record<AdvanceDesignStatus, { background: string; color: string }> = {
  in_progress: { background: '#EAF0F9', color: '#2563A8' },
  disbursed: { background: '#E7F1EA', color: '#15794B' },
  closed: { background: '#EFEFEA', color: '#5A5A52' },
  rejected: { background: '#FBEAE7', color: '#C0392B' },
  queued: { background: '#FBF1DD', color: '#B7791F' },
};

/** Rejected + Queued rows render `—` in every money column. */
export const isMoneyDashStatus = (status: AdvanceDesignStatus): boolean =>
  status === 'rejected' || status === 'queued';
